import { ApplicationRef, ComponentRef, createComponent, EnvironmentInjector } from '@angular/core';

import { ActionButtonComponent } from '@shared/components/action-button-renderer/action-button.component';
import { ActionButtonElement } from '@shared/interfaces/action-button-renderer/action-button-element';
import { ActionButtonRendererCallback } from '@shared/interfaces/action-button-renderer/action-button-renderer-callbacks';
import { Subscription } from 'rxjs';

export function defineActionButtonRenderer(
  environmentInjector: EnvironmentInjector,
  applicationRef: ApplicationRef
) {
  if (!customElements.get('app-angular-cell-renderer')) {
    console.log('Does not exist, defining custom element');
    class AngularCellRenderer extends HTMLElement {
      private subscriptions = new Subscription();
      connectedCallback() {
        const data = (this as ActionButtonElement).data;

        if (!data) {
          console.error('No data provided to ActionButtonComponent');
          return;
        }

        const componentRef = createComponent(ActionButtonComponent, {
          environmentInjector
        });

        componentRef.instance.hasDelete = !!data.onDelete;

        this.addEventSubscriptions(componentRef, data);

        applicationRef.attachView(componentRef.hostView);
        this.appendChild((componentRef.hostView as any).rootNodes[0]);
      }

      disconnectedCallback() {
        this.subscriptions.unsubscribe();
      }

      private addEventSubscriptions(
        componentRef: ComponentRef<ActionButtonComponent>,
        data: ActionButtonRendererCallback
      ) {
        this.subscriptions.add(
          componentRef.instance.detailClick.subscribe(() => {
            data.onDetail();
          })
        );

        this.subscriptions.add(
          componentRef.instance.deleteClick.subscribe(() => {
            if (data.onDelete) {
              data.onDelete();
            }
          })
        );
      }
    }
    customElements.define('app-angular-cell-renderer', AngularCellRenderer);
  }
}
